/**
 * CMS Navigation Context
 * Allows child components to navigate between CMS tabs
 */

import { createContext, useContext } from 'react';
import toast from 'react-hot-toast';

export type CMSTabType = 'global' | 'home' | 'menu-page' | 'reservation' | 'gallery-page' | 'about' | 'contacts' | 'rooftop' | 'menu-items' | 'gallery' | 'sliders' | 'testimonials';

interface CMSNavigationContextType {
  activeTab: CMSTabType;
  navigateTo: (tab: CMSTabType) => void;
}

const CMSNavigationContext = createContext<CMSNavigationContextType | undefined>(undefined);

export const CMSNavigationProvider = CMSNavigationContext.Provider;

export const useCMSNavigation = () => {
  const context = useContext(CMSNavigationContext);
  if (!context) {
    // Return a default implementation if not within provider
    return {
      activeTab: 'global' as CMSTabType,
      navigateTo: (tab: CMSTabType) => {
        toast.error(`Navigation not available. Tab: ${tab}`);
      },
    };
  }
  return context;
};
